/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiSyncTypeFromJSON, ApiSyncTypeToJSON, } from './ApiSyncType';
import { ApiUTMMappingTypeFromJSON, ApiUTMMappingTypeToJSON, } from './ApiUTMMappingType';
export function ApiSimpleUTMFromJSON(json) {
    return ApiSimpleUTMFromJSONTyped(json, false);
}
export function ApiSimpleUTMFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        '_default': !exists(json, 'default') ? undefined : json['default'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'syncType': !exists(json, 'syncType') ? undefined : ApiSyncTypeFromJSON(json['syncType']),
        'type': !exists(json, 'type') ? undefined : ApiUTMMappingTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'utmAdId': !exists(json, 'utmAdId') ? undefined : json['utmAdId'],
        'utmAdgroupId': !exists(json, 'utmAdgroupId') ? undefined : json['utmAdgroupId'],
        'utmCampaign': !exists(json, 'utmCampaign') ? undefined : json['utmCampaign'],
        'utmCampaignId': !exists(json, 'utmCampaignId') ? undefined : json['utmCampaignId'],
        'utmContent': !exists(json, 'utmContent') ? undefined : json['utmContent'],
        'utmMatchType': !exists(json, 'utmMatchType') ? undefined : json['utmMatchType'],
        'utmMedium': !exists(json, 'utmMedium') ? undefined : json['utmMedium'],
        'utmSource': !exists(json, 'utmSource') ? undefined : json['utmSource'],
        'utmSourceAlias': !exists(json, 'utmSourceAlias') ? undefined : json['utmSourceAlias'],
        'utmTerm': !exists(json, 'utmTerm') ? undefined : json['utmTerm'],
    };
}
export function ApiSimpleUTMToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'default': value._default,
        'id': value.id,
        'name': value.name,
        'order': value.order,
        'syncType': ApiSyncTypeToJSON(value.syncType),
        'type': ApiUTMMappingTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'utmAdId': value.utmAdId,
        'utmAdgroupId': value.utmAdgroupId,
        'utmCampaign': value.utmCampaign,
        'utmCampaignId': value.utmCampaignId,
        'utmContent': value.utmContent,
        'utmMatchType': value.utmMatchType,
        'utmMedium': value.utmMedium,
        'utmSource': value.utmSource,
        'utmSourceAlias': value.utmSourceAlias,
        'utmTerm': value.utmTerm,
    };
}
